import React from 'react';
import styled from 'styled-components';
import {VerticalSpacer} from '../../spacer';
import {Typography as Text} from '../../typography';
import {Button} from '../../buttons';
import {Image} from '../../images';
import {WithCaption} from '../../../wraps';
import {FeaturesContentCardProps} from './FeaturesContentCard.big';

const Styled = styled.div`
    .paragraph {
        color: ${(p) => p.theme.palette.text.secondary};
    }

    .h3,
    .paragraph {
        ${(p) => p.theme.breakpoints.up('md')} {
            padding-right: 20px;
        }
    }
    .overlay-caption-wrapper {
        padding-right: 8px;
    }
`;

export const FeaturesContentCardSmall = ({
    title,
    description,
    links = [],
    accentColor = 'sky',
    image = {},
    caption
}: FeaturesContentCardProps): JSX.Element => {
    return (
        <Styled>
            {image && image.src ? (
                <>
                    <WithCaption {...caption}>
                        <Image {...image} />
                    </WithCaption>
                    <VerticalSpacer variant="heading" />
                </>
            ) : (
                ''
            )}

            {title ? (
                <>
                    <Text variant="h3" big>
                        {title}
                    </Text>
                    <VerticalSpacer variant="custom" spacing={2} />
                </>
            ) : (
                ''
            )}

            {description ? <Text variant="p">{description}</Text> : ''}

            {links && links.length ? (
                <>
                    <VerticalSpacer variant="heading" />
                    {links.map((link, index) => (
                        <React.Fragment key={link.href}>
                            <Button type="tertiary" color={accentColor} href={link.href}>
                                {link.label}
                            </Button>
                            {index < links.length - 1 ? <VerticalSpacer variant="paragraph" /> : ''}
                        </React.Fragment>
                    ))}
                </>
            ) : (
                ''
            )}
        </Styled>
    );
};
